import { CandidateInviteDTO } from '@/DTO/Users/CandidateInviteDTO';

export interface Candidate {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    isInternal: boolean;
}

export type CandidateAction = (candidate: Candidate) => void;

export function candidateFromCandidateInviteDTO(dto: CandidateInviteDTO): Candidate {
    return {
        id: dto.candidateId,
        firstName: dto.firstName,
        lastName: dto.lastName,
        email: dto.email,
        isInternal: dto.isInternal,
    };
}
